import React, { useContext, useState, useEffect } from 'react';
import { FarzaaContext } from '../../context/FarzaaContext';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CurrencyContext } from '../../context/CurrencyContext';  


import axios from 'axios';

const apiUrl = import.meta.env.VITE_API_URL;

const RelatedProductSection = ({ brandId, subcategoryId }) => {
    const { t, i18n } = useTranslation();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const { selectedCurrency, currencyImages,value } = useContext(CurrencyContext);
    

    const [error, setError] = useState(null);



    useEffect(() => {
        const fetchRelatedProducts = async () => {
          try {
            const response = await axios.get(
                `${apiUrl}/api/products/search?brand_id=${brandId}&subcategory_id=${subcategoryId}`
              );
            const relatedProducts = response.data.data.slice(0, 4); // Access `data` array
            setProducts(relatedProducts);
            setLoading(false);
          } catch (error) {
            console.error("Error fetching related products:", error);
            setError('Failed to load related products.');
            setLoading(false);
          }
        };
      
        if (brandId) {
          fetchRelatedProducts();
        }
      }, [brandId]);


    if (loading) return <div>Loading related products...</div>;
    if (error) return <div>{error}</div>;

    return (
        <section className="related-product-section">
            <div className="container">
                <h2 className="related-product__title">{t('Related Products')}</h2>
                <div className="row gy-sm-4 g-3 justify-content-center">
                {products.length > 0 ? (
                          products.map((product) => (
                            <div className="col-lg-3 col-md-4 col-6 order-lg-1 order-2" key={product.id}>
                                <div className="fz-5-single-product">
                                    
                                    <div className="fz-5-single-product-img">
                         <Link className="fz-5-single-product-img" to={`/product/${product.slug_en}`}>
                                        
                                        <img src={`${apiUrl}/uploads/${product.image}`} alt={product.title_en} />
                                        </Link>
                                    </div>
                                    <div className="fz-5-single-product-txt">
                                        <h3 className="fz-5-single-product-title">
                                            <Link to={`/product/${product.slug_en}`}>
                                                {i18n.language === 'en' ? product.title_en : product.title_ar}
                                            </Link>
                                        </h3>
                                        <Link to={`/product/${product.slug_en}`}>

                                        <p className="fz-5-single-product-price" style={{ direction: 'ltr' }}>
                                            {t(selectedCurrency)} 
    {selectedCurrency === "SAR" && (
      <img 
        src={currencyImages[selectedCurrency]} 
        alt={selectedCurrency} 
    style={{
      width: '19px', 
      height: 'auto',
      marginRight: '5px', 
      verticalAlign: 'middle', 
    }}      />
    )}
    {(product.selling_price * value).toFixed(2)}
                                            </p>
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>{t('No related products found.')}</p>
                    )}
                </div>
            </div>
        </section>
    );
}

export default RelatedProductSection;